import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Worker, WorkflowDataService } from '@nimmsta/ng-commons-lib';
import { QRResponse } from './response/QRResponse';

@Injectable({ providedIn: 'root' })
export class WorkerService extends WorkflowDataService<Worker> {
  protected override get apiEndpoint(): string {
    return '/worker';
  }

  createQRCode(worker: Worker, unlimitedUse: boolean): Observable<QRResponse> {
    return this.http.post<QRResponse>(`${this.baseUrl}/auth/QR/${worker.id}`, { unlimitedUse });
  }

  getQRCode(qrCodeId: string): Observable<QRResponse> {
    return this.http.get<QRResponse>(`${this.baseUrl}/auth/QR/${qrCodeId}`);
  }

  unpair(worker: Worker): Observable<Worker> {
    return this.http.post<Worker>(`${this.baseUrl}/worker/${worker.id}/unpair`, {});
  }
}
